export default __webpack_public_path__ + "static/microsoft baseline security analyzer-7c2390608261bb0f916dce3c4446ec14.png";